import { FC } from 'react'
import { formatDate } from '@core/utils/time'
import ExpandableList from '@components/expandable-list'
import { DetailsGrid } from '@ui/drawer/common/DetailsGrid'
import { InfoItem } from '@ui/drawer/common/infoItem'
import Typography from '@/ui/components/typography'
import { DeviceWrapper, DomainItem } from './assetDeviceInfo.styles'

type TAssetInfoProps = {
    asset: TAsset
}

const AssetDeviceInfo: FC<TAssetInfoProps> = ({ asset }) => {
    const {
        hostname,
        ip_addresses: ipAddresses,
        created_at: createdAt,
        domains,
    } = asset

    const primaryIp = ipAddresses?.[0]?.ip_address
    const hasMultipleIps = (ipAddresses?.length ?? 0) > 1
    const showBusinessNetwork =
        (domains && domains.length > 0) || hasMultipleIps

    return (
        <DeviceWrapper>
            <DetailsGrid dataTestId="device-details-grid">
                <InfoItem title="Name" dataTestId="device-name">
                    {hostname || '-'}
                </InfoItem>
                <InfoItem title="IP Address" dataTestId="device-ip-address">
                    {primaryIp || '-'}
                </InfoItem>
                <InfoItem title="Created At" dataTestId="device-created-at">
                    {createdAt ? formatDate(createdAt) : '-'}
                </InfoItem>
            </DetailsGrid>
            {showBusinessNetwork && (
                <DetailsGrid dataTestId="device-network-grid">
                    {domains && domains.length > 0 && (
                        <InfoItem
                            title="Associated Domains"
                            dataTestId="device-associated-domains"
                        >
                            {domains.map(({ domain }: TDeviceDomains) => (
                                <DomainItem key={domain} data-testid="domain">
                                    <Typography variant="s-regular">
                                        {domain}
                                    </Typography>
                                </DomainItem>
                            ))}
                        </InfoItem>
                    )}
                    {hasMultipleIps && ipAddresses && (
                        <InfoItem
                            title="Additional IPs"
                            dataTestId="device-additional-ips"
                        >
                            <ExpandableList
                                maxItemsToShow={2}
                                list={ipAddresses.slice(1)}
                                renderItem={({ ip_address: ip }) => (
                                    <Typography
                                        key={ip}
                                        variant="s-regular"
                                        testId="device-additional-ip"
                                    >
                                        {ip}
                                    </Typography>
                                )}
                            />
                        </InfoItem>
                    )}
                </DetailsGrid>
            )}
        </DeviceWrapper>
    )
}

export default AssetDeviceInfo
